import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { ValidateCouponRequest, ValidateCouponResponse } from '../../types/coupon';

export async function httpValidateCoupon(
  request: ValidateCouponRequest,
): Promise<ValidateCouponResponse> {
  return apiClient<ValidateCouponResponse>(endpoints.coupons.validate, {
    method: 'POST',
    body: request,
    auth: false,
  });
}
